import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
export const Icon = styled.div`
  margin-bottom: 3px;
`;
export const Title = styled.p``;
